"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeInfoClient = void 0;
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const NodeInfoRpcRemote_1 = require("./NodeInfoRpcRemote");
class NodeInfoClient {
    ownPeerDescriptor;
    rpcCommunicator;
    constructor(ownPeerDescriptor, rpcCommunicator) {
        this.ownPeerDescriptor = ownPeerDescriptor;
        this.rpcCommunicator = rpcCommunicator;
    }
    async getInfo(node) {
        const remote = new NodeInfoRpcRemote_1.NodeInfoRpcRemote(this.ownPeerDescriptor, node, this.rpcCommunicator, NetworkRpc_client_1.NodeInfoRpcClient);
        // TODO remove casting when we validate NodeInfoResponse messages and therefore can annotate
        // each of the field as required in the decorated type
        return remote.getInfo();
    }
}
exports.NodeInfoClient = NodeInfoClient;
//# sourceMappingURL=NodeInfoClient.js.map